import React from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';

const { RangePicker } = DatePicker;

const DateRangePicker = ({ onChange, style }) => {
	const today = moment();
	const yesterday = moment().subtract(1, 'day');
	const last7Days = [moment().subtract(6, 'days'), today];
	const last30Days = [moment().subtract(29, 'days'), today];
	const thisMonth = [moment().startOf('month'), moment().endOf('month')];
	const lastMonth = [
		moment().subtract(1, 'month').startOf('month'),
		moment().subtract(1, 'month').endOf('month'),
	];
	const thisYear = [moment().startOf('year'), moment().endOf('year')];
	const lastYear = [
		moment().subtract(1, 'year').startOf('year'),
		moment().subtract(1, 'year').endOf('year'),
	];

	const predefinedRanges = {
		'Hôm nay': [today, today],
		'Hôm qua': [yesterday, yesterday],
		'7 ngày qua': last7Days,
		'30 ngày qua': last30Days,
		'Tháng này': thisMonth,
		'Tháng trước': lastMonth,
		'Năm nay': thisYear,
		'Năm trước': lastYear,
	};

	return (
		<RangePicker
			style={style}
			format="DD/MM/YYYY"
			ranges={predefinedRanges}
			defaultValue={[today, today]} // Mặc định: 30 ngày qua
			onChange={onChange}
			allowClear={false}
		/>
	);
};

export default DateRangePicker;
